import { QueryClient } from "@tanstack/react-query";
import { PostHog } from "posthog-js";
import { canAccessParticipantJobDetail } from "~/shared/lib/posthog/posthog.helper";
import { notFound } from "~/shared/util/notFound";

export function jobViewLoader(queryClient: QueryClient, postHog?: PostHog) {
  const canAccess = canAccessParticipantJobDetail(postHog);

  if (!canAccess) {
    return notFound();
  }

  return null;
}
